import { SET_SHARE_CONTEXT, CLEAR_SHARE_CONTEXT } from './actions';

export const initialState = {
  companyName: null,
  companyUrl: null,
  investorName: null,
};

export const ThankYouReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SHARE_CONTEXT:
      return {
        ...state,
        ...action.payload,
      };
    case CLEAR_SHARE_CONTEXT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default ThankYouReducer;
